import { Order } from './order';
import { Address } from './company';
import { t } from '../locales/translate';
import { Option } from '../components/Form/Select/Select';
import { BasePermissions } from './permission';
import { Delivery, DeliveryStatus } from './delivery';
import { Invoice, InvoiceStatus } from './invoice';

/* INTERFACE */
export type DocumentStatus = InvoiceStatus | DeliveryStatus;

export interface Document {
  id: string;
  reference: string;
  orderId?: string;
  order?: Order;
  address: Address;
  createdAt: Date;
  updatedAt: Date;
  documentUrl?: string;
  $permissions: Array<BasePermissions | 'unbook'>;
}

export function getDocumentFieldOptions(
  documents: Array<Invoice | Delivery>,
  documentType: 'invoice' | 'delivery'
): Option[] {
  return [
    ...documents
      .filter((doc) => doc.status === 'draft' || doc.status === 'pending')
      .map((inv) => ({
        value: inv.id,
        label: inv.reference,
      })),
    {
      value: 'new',
      label: t.model[documentType].new,
    },
    {
      value: 'no',
      label: t.model[documentType].no,
    },
  ];
}
